<template>

    <div>

        <app-header :settings='settings' :showdeclarers='showdeclarers'></app-header>

        <div class="page__main container" v-if="isLoadData">
            <div class="page__index block-index">
                <div class="settings settings--short">
                    <div class="settings__item head-card card">
                        <div class="head-card__body">
                            <div class="head-card__title h3">Контактные данные</div>
                            <div v-if="isphonenumberverified === 'true' && isemailverified === 'true'" class="head-card__caption" style="color: #343a4a;">Указанные контактные данные используются для мультилогина (авторизации на портале), получения уведомлений, восстановления пароля, доставки онлайн-чеков и др.</div>
                            <div v-else class="head-card__caption" style="color: red">Заполните недостающие контактные данные или измените (при необходимости), чтобы использовать мультилогин (авторизации на портале), восстановить доступ к профилю, получать уведомления и онлайн-чеки.</div>
                        </div>
                        <div class="head-card__icon">
                            <img src="/images/card-head-icons/personal.svg" alt="">
                        </div>
                    </div>

                    <change-username :user="user" @update="updateUserName"></change-username>

                    <change-login :user="user" @update="updateUserLogin"></change-login>

                    <change-password :user="user"></change-password>

                    <change-email :user="user" :isemailverified="isemailverified" :isphonenumberverified="isphonenumberverified" @update="updateUserEmail" @verified="isemailverified = 'true'"></change-email>

                    <change-phone :user="user" :isemailverified="isemailverified" :isphonenumberverified="isphonenumberverified" @update="updateUserPhone" @verified="isphonenumberverified = 'true'"></change-phone>

                    <div class="settings__item data-card block">
                        <div class="data-card__head data-card__head--social">
                            <div class="data-card__social">
                                <div class="data-card__social-item">
                                    <a href="https://vk.com/sibgenco?_smt=search%3A1" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#5181B8"></rect>
                                                <path d="M20.7743 25.3289C21.1803 25.3289 21.3463 25.0583 21.3416 24.719C21.3209 23.441 21.8176 22.7531 22.7142 23.6497C23.7062 24.6416 23.9115 25.3289 25.1161 25.3289H27.2494C27.788 25.3289 28 25.1556 28 24.8836C28 24.3083 27.0527 23.293 26.2501 22.5477C25.1261 21.5044 25.0735 21.4798 26.0414 20.2238C27.242 18.6646 28.8126 16.6666 27.4234 16.6666H24.7695C24.2548 16.6666 24.2175 16.9566 24.0342 17.3886C23.3709 18.9532 22.1102 20.9798 21.6316 20.6698C21.131 20.3465 21.3603 19.0659 21.3983 17.1626C21.4083 16.66 21.4056 16.3153 20.6376 16.1367C20.2183 16.04 19.8103 16 19.4317 16C17.9164 16 16.8711 16.6353 17.4651 16.746C18.5124 16.9413 18.4117 19.2072 18.1677 20.1858C17.7424 21.8898 16.1438 18.8365 15.4779 17.3159C15.3172 16.9506 15.2679 16.6666 14.6946 16.6666H12.5246C12.1967 16.6666 12 16.7733 12 17.0106C12 17.4119 13.9733 21.4904 15.8572 23.5237C17.6944 25.5069 19.5104 25.3289 20.7743 25.3289Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">СГК в ВКонтакте</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://www.youtube.com/channel/UC0CIuVWEInnM1jFCd9Txxxw " class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_2801_531)">
                                                    <path class="rect" d="M17.5088 23.7467L24.0145 19.9999L17.5088 16.2529V23.7467Z" fill="#FF0000"></path>
                                                    <path class="rect" d="M20 0C8.956 0 0 8.956 0 20C0 31.044 8.956 40 20 40C31.044 40 40 31.044 40 20C40 8.956 31.044 0 20 0ZM32.497 20.0205C32.497 20.0205 32.497 24.0765 31.9825 26.0323C31.694 27.103 30.8498 27.947 29.7793 28.2352C27.8235 28.75 20 28.75 20 28.75C20 28.75 12.197 28.75 10.2206 28.2147C9.15008 27.9267 8.30597 27.0822 8.01758 26.0117C7.50275 24.0765 7.50275 20 7.50275 20C7.50275 20 7.50275 15.9442 8.01758 13.9883C8.30567 12.9178 9.17053 12.0529 10.2206 11.7648C12.1765 11.25 20 11.25 20 11.25C20 11.25 27.8235 11.25 29.7793 11.7853C30.8498 12.0734 31.694 12.9178 31.9825 13.9883C32.5177 15.9442 32.497 20.0205 32.497 20.0205Z" fill="#FF0000"></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2801_531">
                                                        <rect width="40" height="40" fill="white"></rect>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">СГК в YouTube</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://t.me/sibgencoonline" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал СГК Онлайн (общий)</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://tlgg.ru/sgk_nsk" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал СГК Новосибирск</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://tlgg.ru/sgk_krsk" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал СГК Красноярск (общий)</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://t.me/SGC_client" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал Красноярск (прямые договора)</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://tlgg.ru/sgk_kuzbass" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал СГК Кузбасс</div>
                                        </div>
                                    </a>
                                </div>

                                <div class="data-card__social-item">
                                    <a href="https://tlgg.ru/sgk_barnaul" class="data-card__social-link" target="_blank">
                                        <div class="data-card__social-icon">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="40" height="40" rx="20" fill="#0D86D7"></rect>
                                                <path d="M18.5133 22.3597L18.1716 25.9905C18.1716 25.9905 18.0286 27.103 19.1409 25.9905C20.2531 24.878 21.3178 24.0201 21.3178 24.0201" fill="white"></path>
                                                <path d="M16.1858 21.2722L12.525 20.0795C12.525 20.0795 12.0875 19.902 12.2284 19.4995C12.2574 19.4165 12.3159 19.3459 12.4909 19.2245C13.302 18.6591 27.5041 13.5545 27.5041 13.5545C27.5041 13.5545 27.9051 13.4194 28.1416 13.5092C28.2001 13.5274 28.2528 13.5607 28.2942 13.6058C28.3356 13.6509 28.3643 13.7063 28.3773 13.7661C28.4028 13.8718 28.4135 13.9806 28.409 14.0892C28.4079 14.1832 28.3965 14.2704 28.3879 14.407C28.3014 15.8026 25.7129 26.2186 25.7129 26.2186C25.7129 26.2186 25.558 26.8281 25.0031 26.849C24.8668 26.8534 24.7309 26.8303 24.6037 26.7811C24.4764 26.7319 24.3604 26.6575 24.2625 26.5625C23.1736 25.6259 19.4101 23.0966 18.5785 22.5404C18.5598 22.5276 18.544 22.5109 18.5322 22.4915C18.5204 22.4721 18.5129 22.4504 18.5103 22.4279C18.4986 22.3692 18.5624 22.2966 18.5624 22.2966C18.5624 22.2966 25.1156 16.4716 25.29 15.8601C25.3035 15.8127 25.2525 15.7894 25.184 15.8101C24.7488 15.9702 17.2035 20.7351 16.3708 21.261C16.3108 21.2791 16.2475 21.283 16.1858 21.2722Z" fill="white"></path>
                                            </svg>
                                        </div>
                                        <div class="data-card__social-hint">
                                            <div class="help__inner">Телеграм канал СГК Барнаул</div>
                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>
                        <div class="data-card__social-text" style="margin-bottom: 10px;">
                            Подключайтесь к нашим чат-ботам в соц.сетях, решайте вопросы и передавайте показания приборов учёта он-лайн.
                        </div>
                    </div>
                    <div class="settings__item data-card block">
                        <div class="data-card__head">
                            <div class="data-card__title">
                                <span v-if="(user.CreatedDate)!=null" class="data-card__label">Профиль: Активен с {{user.CreatedDate | formatDate}}</span>
                            </div>
                            <div class="data-card__link">
                                <a href="#dataCard_profile" class="link link--present status-error" data-toggle="collapse">
                                    <span class="link__text" style="display: none;">Удалить профиль</span>
                                </a>
                            </div>
                        </div>
                        <div class="data-card__head data-card__head--info">
                            <div class="data-card__title">
                                <a href="/site/useragreement" target="_blank" class="link link--primary link--pseudo-rev">
                                    <span class="link__text">
                                        Пользовательское соглашение 1.1
                                    </span>
                                </a>
                            </div>
                            <div class="data-card__links-block">
                                <div class="data-card__links-item">
                                    <span>Дата и время ознакомления с пользовательским соглашением:</span>
                                    <span>{{user.UserAgreementDate | formatDate}}</span>
                                    <span>{{user.UserAgreementDate | formatTime}}</span>
                                </div>
                                <!--<div class="data-card__links-item">-->
                                <!--<span>Время:</span>-->
                                <!--<span>{{user.UserAgreementDate | formatTime}}</span>
                                </div>-->

                            </div>
                        </div>
                    </div>

                    <div style="display: none;">
                        <!--Удаление профиля и пользовательское соглашение не реализовано-->
                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__title">
                                    <span class="data-card__label">Профиль: Активен с </span>
                                </div>
                                <div class="data-card__link">
                                    <a href="#dataCard_profile" class="link link--present status-error" data-toggle="collapse"><span class="link__text">Удалить профиль</span></a>
                                </div>
                            </div>
                            <div class="data-card__head data-card__head--info">
                                <div class="data-card__title">
                                    <a href="#" target="_blank" class="link link--primary link--pseudo-rev">
                                        <span class="link__text">
                                            Пользовательское соглашение 1.01
                                        </span>
                                    </a>
                                </div>
                                <div class="data-card__links-block">
                                    <div class="data-card__links-item">
                                        <span>Дата:</span>
                                        <span>01.01.2022</span>
                                    </div>
                                    <div class="data-card__links-item">
                                        <span>Время:</span>
                                        <span>12:30</span>
                                    </div>

                                </div>
                            </div>
                            <div id="dataCard_profile" class="data-card__form data-card__form--full accordion-body collapse">
                                <div class="data-card__inner accordion-body__inner js-remove-profile-container">
                                    <div class="b-form-sm">
                                        <div class="remove-profile__title">Выберите способ отправки кода для удаления профиля</div>
                                        <div class="remove-profile__item js-remove-profile">
                                            <div class="remove-profile__head">
                                                <span class="remove-profile__text">Адрес электроной почты: <span class="status-primary">zaoiris@test.epp</span></span>
                                            </div>
                                            <div class="b-form-sm__body">
                                                <div class="b-form-sm__item">
                                                    <label class="txt-input js-input-contact">
                                                        <div class="txt-input__input">
                                                            <input class="txt-input__field input" type="text" value="zaoiris@test.epp">
                                                        </div>
                                                    </label>
                                                    <label class="txt-input js-input-code" style="display: none;">
                                                        <div class="txt-input__input">
                                                            <input class="txt-input__field input" type="text" placeholder="Введите код">
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="b-form-sm__item remove-buttons-container">
                                                    <button class="button button--th-second js-remove-profile-trigger">Получить код</button>
                                                    <button class="button button--th-main js-remove-profile-next" style="display: none;">Продолжить</button>
                                                    <button class="button button--th-main js-profile-code-again" style="display: none;">Отправить еще раз</button>
                                                    <a href="#" class="button button--th-error js-remove-profile-remove" style="display: none;">Удалить профиль</a>
                                                    <a href="#dataCard_profile" class="button button--th-link" data-toggle="collapse">Отменить</a>
                                                    <div class="form-timer form-timer--profile js-timer">
                                                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                            <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
														M 50, 50
														m -45, 0
														a 45,45 0 1,0 90,0
														a 45,45 0 1,0 -90,0
														"></path>
                                                        </svg>
                                                        <span class="js-timer-count form-timer__count">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="remove-profile__item js-remove-profile">
                                            <div class="remove-profile__head">
                                                <span class="remove-profile__text">Номер сотового телефона: <span class="status-primary">+7-483-124-7444</span></span>
                                                <a href="#" class="remove-profile__error status-error link link--present"><span class="link__text">Не подтвержден</span></a>
                                            </div>
                                            <div class="b-form-sm__body">
                                                <div class="b-form-sm__item">
                                                    <label class="txt-input js-input-contact">
                                                        <div class="txt-input__input">
                                                            <input class="txt-input__field input" type="text" value="+7-483-124-7444">
                                                        </div>
                                                    </label>
                                                    <label class="txt-input js-input-code" style="display: none;">
                                                        <div class="txt-input__input">
                                                            <input class="txt-input__field input" type="text" placeholder="Введите код">
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="b-form-sm__item remove-buttons-container">
                                                    <a href="" class="button button-icon--th-ctrl is-disable">Недоступно</a>
                                                    <button class="button button--th-second js-remove-profile-trigger" style="display: none;">Получить код</button>
                                                    <button class="button button--th-main js-remove-profile-next" style="display: none;">Продолжить</button>
                                                    <button class="button button--th-main js-profile-code-again" style="display: none;">Отправить еще раз</button>
                                                    <a href="#" class="button button--th-error js-remove-profile-remove" style="display: none;">Удалить профиль</a>
                                                    <a href="#dataCard_profile" class="button button--th-link" data-toggle="collapse">Отменить</a>
                                                    <div class="form-timer form-timer--profile js-timer">
                                                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                            <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
														M 50, 50
														m -45, 0
														a 45,45 0 1,0 90,0
														a 45,45 0 1,0 -90,0
														"></path>
                                                        </svg>
                                                        <span class="js-timer-count form-timer__count">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="remove-profile__item js-remove-profile-message" style="display: none;">
                                            <div class="status-error">
                                                Введите проверочный код и нажмите кнопку "Продолжить" для удаления вашего профиля.
                                                <br>
                                                При повторной авторизации в течение 30 дней и вводе проверочного кода он будет автоматически восстеновлен.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="settings__item data-card block">
                        <div class="data-card__head">
                            <div class="data-card__title">
                                <span class="data-card__label"><sup>*</sup> - Логин, номер сотового телефона и основного e-mail адреса, подключенные к Вашему профилю, должны быть уникальны и могут присутствовать только в данном профиле. При необходимости объединить несколько профилей в один - необходимо <a href="#" class="link link--primary"><span class="link__text">выполнить перенос лицевых счетов</span></a> в данный профиль и удалить старый профиль. Восстановление/изменение пароля возможно только по подтверждённым контактным данным в Вашем профиле.</span>
                            </div>
                        </div>
                    </div>

                    <div class="settings__item head-card card">
                        <div class="head-card__body">
                            <div class="head-card__caption">В соответствии с требованиями ФЗ-54 от 22.05.2003, вышеуказанные данные используются для отправки онлайн-чеков.</div>
                        </div>
                    </div>

                    <div class="settings__item head-card head-card--light-fill card">
                        <div class="head-card__body">
                            <div class="head-card__title h3">Дополнительные контактные данные</div>
                            <div class="head-card__caption">Заполните контактные данные, чтобы удобно получать уведомления</div>
                        </div>
                    </div>

                    <change-extra-email :user="user" @update="updateUserExtraEmail"></change-extra-email>

                    <change-extra-phone :user="user" @update="updateUserExtraPhone"></change-extra-phone>

                    <change-city-phone :user="user" @update="updateUserCityPhone"></change-city-phone>

                    <change-work-phone :user="user" @update="updateUserWorkPhone"></change-work-phone>

                    <div class="settings__item head-card card">
                        <div class="head-card__body">
                            <div class="head-card__caption">В соответствии с требованиями ФЗ-54 от 22.05.2003, вышеуказанные данные используются для отправки онлайн-чеков.</div>
                        </div>
                    </div>
                    
                    <div class="settings__item head-card head-card--light-fill card">
                        <div class="head-card__body">
                            <div class="head-card__title h3">
                                <a name="add-card"></a>
                                Банковские карты
                            </div>
                            <div class="head-card__caption">Добавьте банковские карты для быстрой оплаты на портале: у сохранённых банковских карт списание денежных средств происходит без кода подтверждения.</div>
                        </div>
                    </div>

                    <div v-for="card in cardsList">
                        <view-cards :card="card" @defaultCard="defaultCard"></view-cards>
                    </div>

                    <div class="bank-card__link">
                        <div class="add-drop">
                            <a href="" class="add-drop__toggle link link--underline" data-toggle="dropdown">
                                <div class="link__icon fab-icon fab-icon--second">
                                    <i class="icon icon--add"></i>
                                </div>
                                <div class="link__text">Добавить карту</div>
                            </a>
                            <div class="add-drop__drop add-drop__drop--top" v-if="kz | fl | (ul>0) | ukz | ups">
                                <div class="add-drop__drop-inner">
                                    <a v-if="fl" href="/Profiles/AddCard/FL" class="button button--th-main">Для оплаты ЛС физ.лиц (Газпромбанк)</a>
                                    <a v-if="fl" href="/Profiles/AddCard/SB" class="button button--th-main">Для оплаты ЛС физ.лиц (Сбербанк)</a>
                                    <a v-if="kz" href="/Profiles/AddCard/KZ" class="button button--th-main">Для оплаты ЛС АО "Кызыльская ТЭЦ"<br />физ.лиц (Газпромбанк)</a>
                                    <a v-if="ul>0" v-bind:href="'/Profiles/AddCardU/' + ul" class="button button--th-main">Для оплаты ЛС юр.лиц (Газпромбанк)</a>
                                    <a v-if="ukz" href="/Profiles/AddCardU/72" class="button button--th-main">Для оплаты ЛС АО "Кызыльская ТЭЦ"<br />юр.лиц (Газпромбанк)</a>
                                    <a v-if="ups" href="/Profiles/AddCardU/120" class="button button--th-main">Для оплаты ЛС ООО "ЮСТК"<br />с.Подсинее юр.лиц (Газпромбанк)</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-error-alert message="Данный раздел недоступен по техническим причинам" v-if="isError && !isLoadData"></app-error-alert>
    </div>
</template>
<script>
    import ProfilesHeader from './ProfilesHeader.vue';
    import ErrorAlert from './ErrorAlert.vue';
    import ChangePassword from './ChangePassword.vue';
    import ChangeEmail from './ChangeEmail.vue';
    import ChangeLogin from './ChangeLogin.vue';
    import ChangePhone from './ChangePhone.vue';
    import ChangeExtraEmail from './ChangeExtraEmail.vue';
    import ChangeExtraPhone from './ChangeExtraPhone.vue';
    import ChangeCityPhone from './ChangeCityPhone.vue';
    import ChangeWorkPhone from './ChangeWorkPhone.vue';
    import ChangeUserName from './ChangeUserName.vue';
    import ViewCards from './ViewCards.vue';
    export default {
        name: 'settings',
        props: ['data', 'isphonenumberverified', 'isemailverified', 'cards', 'accounts', 'accountsu', 'showdeclarers'],
        components: {
            'app-header': ProfilesHeader,
            'app-error-alert': ErrorAlert,
            'change-password': ChangePassword,
            'change-email': ChangeEmail,
            'change-login': ChangeLogin,
            'change-phone': ChangePhone,
            'change-extra-email': ChangeExtraEmail,
            'change-extra-phone': ChangeExtraPhone,
            'change-city-phone': ChangeCityPhone,
            'change-work-phone': ChangeWorkPhone,
            'change-username': ChangeUserName,
            'view-cards': ViewCards
        },
        created: function () {
            this.loadData();
        },
        data: function () {
            return {
                settings: { name: this.$options.name },
                isLoadData: false,
                isError: false,
                user: {},
                cardsList: "",
                kz: false,
                fl: false,
                ul: 0,
                ukz: false,
                ups: false
            }
        },
        filters: {
            formatDate: function (value) {
                if (value) {
                    var d = value.substring(8, 10);
                    var m = value.substring(5, 7);
                    var y = value.substring(0, 4);
                    return d + "." + m + "." + y;
                }
            },

            formatTime: function (value) {
                if (value) {
                    var time = value.substring(11, 16);
                    return time;
                }
            },
        },
        methods: {
            defaultCard: function (card) {
                for (var index in this.cardsList) {
                    if (this.cardsList[index].MerchCode === card.MerchCode)
                        this.cardsList[index].IsDefault = false;
                }
                card.IsDefault = true;
            },
            loadData: function () {
                this.user = JSON.parse(this.data).Items[0];
                this.cardsList = JSON.parse(this.cards);
                this.cardsList.sort(function (a, b) {
                    if (a.MerchCode < b.MerchCode)
                        return -1;
                    return 1;
                });
                this.isLoadData = true;
                console.log('showdeclarers:' + this.showdeclarers);
            },
            updateUserEmail: function (email) {
                this.user.Email = email;
            },
            updateUserExtraEmail: function (email) {
                this.user.ExtraEmail = email;
            },
            updateUserLogin: function (login) {
                this.user.UserName = login;
            },
            updateUserPhone: function (phone) {
                this.user.PhoneNumber = phone;
                console.log(user);
            },
            updateUserExtraPhone: function (phone) {
                this.user.ExtraPhone = phone;
            },
            updateUserCityPhone: function (phone) {
                this.user.CityPhone = phone;
            },
            updateUserWorkPhone: function (workPhone) {
                this.user.MainWorkPhone = workPhone.MainWorkPhone;
                this.user.ExtraWorkPhone = workPhone.ExtraWorkPhone;
            },
            updateUserName: function (userName) {
                this.user.FirstName = userName.FirstName;
                this.user.MiddleName = userName.MiddleName;
            },
            userAgreementDate: function (userDate) {
                this.user.UserAgreementDate = userDate.UserAgreementDate;
            },
        },
        mounted: function () {
            if (this.accounts) {
                var acc = JSON.parse(this.accounts);
                for (var index in acc) {
                    if (acc[index].BspId.toUpperCase() === 'KYZL')
                        this.kz = true;
                    else
                        this.fl = true;
                }
            }

            if (this.accountsu) {
                acc = JSON.parse(this.accountsu);
                for (var index in acc) {
                    switch (acc[index].DivisionId) {
                        case "72":
                            this.ukz = true;
                            break;
                        case "120":
                            this.ups = true;
                            break;
                        default:
                            this.ul = acc[index].DivisionId;
                            break;
                    }
                }
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// Scripts/app/profiles/components/Settings.vue